import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play, X } from "@phosphor-icons/react";
import { formatDuration } from "@/lib/api";
import { getContinueList, clearProgress } from "@/lib/progress";
import { onImgError } from "@/lib/fallback";

export const ContinueWatchingRow = () => {
  const [items, setItems] = useState(getContinueList());

  useEffect(() => {
    const refresh = () => setItems(getContinueList());
    window.addEventListener("progress-change", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener("progress-change", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="mb-12" data-testid="continue-watching-row">
      <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-[#EDEDED] mb-5">Continue Watching</h2>
      <div className="flex gap-4 rv-snap-row overflow-x-auto hide-scrollbar pb-2 -mx-1 px-1">
        {items.map((p, idx) => {
          const pct = Math.min(100, Math.round((p.timestamp / p.duration) * 100));
          const remaining = Math.max(0, Math.round(p.duration - p.timestamp));
          return (
            <Link
              key={p.video_id || idx}
              to={`/watch/${p.video_id}`}
              data-testid={`continue-card-${p.video_id}`}
              className="rv-row-card group relative w-[280px] sm:w-[320px] shrink-0 block"
            >
              <div className="aspect-video relative overflow-hidden bg-ink-surface border border-white/10 group-hover:border-amber/60 transition-colors duration-300">
                <img src={p.thumb} alt={p.title} loading="lazy" onError={onImgError} className="h-full w-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <Play size={48} weight="fill" className="text-amber drop-shadow-lg" />
                </div>
                <span className="absolute bottom-3 left-2 bg-black/80 px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.1em] text-amber">
                  {formatDuration(remaining)} left
                </span>
                <button
                  data-testid={`continue-remove-${p.video_id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    clearProgress(p.video_id);
                  }}
                  aria-label="Remove from Continue Watching"
                  className="absolute top-2 right-2 p-1.5 border border-white/20 bg-black/50 text-white/70 opacity-100 sm:opacity-0 group-hover:opacity-100 hover:border-crimson hover:text-crimson transition-colors duration-300"
                >
                  <X size={16} weight="bold" />
                </button>
                <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-black/50">
                  <div className="h-full bg-amber" style={{ width: `${pct}%` }} />
                </div>
              </div>
              <h3 className="pt-3 font-serif text-xl leading-tight text-[#EDEDED] truncate group-hover:text-amber transition-colors duration-300">
                {p.title}
              </h3>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
